import React, { useState } from 'react';
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Chip,
  CircularProgress,
  Stack,
  Modal,
  Box,
  IconButton
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';

import { API_URL } from '../services/api';
import DownloadImage from './DownloadImage';

function ImageList({ files, onClassify, classificationResults, classifyingFiles }) {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (file) => {
    setSelectedImage(file);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '90vw',
    maxHeight: '90vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    borderRadius: 1,
    outline: 'none'
  };

  return (
    <>
      <Grid container spacing={2}>
      {files.map((file) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={file.filename}>
          <Card>
            <CardMedia
              component="img"
              height="140"
              image={`${API_URL}/image/${file.filename}`}
              alt={file.filename}
              onClick={() => handleImageClick(file)}
              sx={{ cursor: 'pointer' }}
            />
            <CardContent>
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }} gutterBottom>
                  {file.filename}
                </Typography>
                {/* Download image with classificationResults as prefix */}
                {classificationResults[file.filename] && (
                  <DownloadImage imageUrl={`${API_URL}/image/${file.filename}`} imageName={classificationResults[file.filename].category ? `[${classificationResults[file.filename].category}]${file.filename}` : file.filename} />
                )}
              </Stack>
              <Stack direction="row" spacing={0.5} mt={1} alignItems="center">
                <Button
                  variant="outlined"
                  size="small"
                  sx={{ flexShrink: 0 }}
                  onClick={() => onClassify(file.filename)}
                  disabled={classifyingFiles[file.filename]}
                  startIcon={classificationResults[file.filename] ? undefined : <VisibilityIcon fontSize='small' />}
                >
                  {classifyingFiles[file.filename] ? (
                    <CircularProgress size={23} />
                  ) : (
                    '识别'
                  )}
                </Button>
                {classificationResults[file.filename] && (
                  <>
                    <Chip
                      // variant="outlined"
                      color="warning"
                      label={classificationResults[file.filename].category}
                      size="small"
                      // sx={{ ml: 2 }}
                    />
                    {classificationResults[file.filename].color && (
                      <Chip
                        // variant="outlined"
                        color="info"
                        label={classificationResults[file.filename].color}
                        size="small"
                        // sx={{ ml: 0.5 }}
                      />
                    )}
                    {classificationResults[file.filename].characteristic && (
                      <Chip
                        // variant="outlined"
                        color="success"
                        label={classificationResults[file.filename].characteristic}
                        size="small"
                        // sx={{ ml: 0.5 }}
                      />
                    )}
                  </>
                )}
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>

    {/* Preview Modal */}
    <Modal
      open={!!selectedImage}
      onClose={handleCloseModal}
      aria-labelledby="image-preview-modal"
      aria-describedby="image-preview-modal-description"
    >
      <Box sx={modalStyle}>
        {selectedImage && (
          <Stack spacing={2}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="h6" component="h2">
                {selectedImage.filename}
              </Typography>
              <IconButton onClick={handleCloseModal} size="small">
                <CloseIcon />
              </IconButton>
            </Stack>
            <Box
              component="img"
              src={`${API_URL}/image/${selectedImage.filename}`}
              alt={selectedImage.filename}
              sx={{
                maxWidth: '100%',
                maxHeight: '70vh',
                objectFit: 'contain',
                borderRadius: 1
              }}
            />
            {classificationResults[selectedImage.filename] && (
              <Stack direction="row" spacing={1} flexWrap="wrap">
                <Chip
                  color="warning"
                  label={classificationResults[selectedImage.filename].category}
                  size="small"
                />
                {classificationResults[selectedImage.filename].color && (
                  <Chip
                    color="info"
                    label={classificationResults[selectedImage.filename].color}
                    size="small"
                  />
                )}
                {classificationResults[selectedImage.filename].characteristic && (
                  <Chip
                    color="success"
                    label={classificationResults[selectedImage.filename].characteristic}
                    size="small"
                  />
                )}
              </Stack>
            )}
          </Stack>
        )}
      </Box>
    </Modal>
    </>
  );
}

export default ImageList;